var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({
    width: _vm.width + 'px',
    height: _vm.width + 'px',
    'display': 'inline-block',
    'vertical-align': 'middle',
    color: _vm.color
  })},[_c('svg',{staticClass:"m-icon-arrow",style:({
      transition: 'all 0.3s ease',
      transform: 'rotate(' + _vm.rotate +')'
    }),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 35 35","fill":"currentColor"}},[_c('path',{attrs:{"d":"M9.4,13.9c-0.2,0.2-0.2,0.6,0,0.8l8.1,8.1l0,0l0,0l8.1-8.1c0.2-0.2,0.2-0.6,0-0.8l-1.3-1.3 c-0.2-0.2-0.6-0.2-0.8,0l-5.5,5.5c-0.2,0.2-0.6,0.2-0.8,0l-5.5-5.5c-0.2-0.2-0.6-0.2-0.8,0L9.4,13.9z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }